import {
    CREATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    RETRIEVE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    RETRIEVESINGLE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    UPDATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
    DELETE_ARCHITECTURESERVEREMPLOYEEWORKDAYS,
  } from "../actions/type";
  const initialState = [];
  function ARCServerEmployeeWorkDaysReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS:
        return {data: state.data, payload};
      case RETRIEVE_ARCHITECTURESERVEREMPLOYEEWORKDAYS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_ARCHITECTURESERVEREMPLOYEEWORKDAYS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_ARCHITECTURESERVEREMPLOYEEWORKDAYS:
        return {data: state.data, payload};
      case DELETE_ARCHITECTURESERVEREMPLOYEEWORKDAYS:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {ARCServerEmployeeWorkDaysReducer};